import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {
  productosPath,
  paths,
  key_local_linea_nego,
} from 'src/app/shared/helpers/constants';
import { AuthService } from 'src/app/shared/services/auth.service';
import { removeLocalStorage } from 'src/app/shared/helpers/helper';

@Component({
  selector: 'app-identify',
  templateUrl: './identify.component.html',
  styleUrls: ['./identify.component.scss'],
})
export class IdentifyComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    removeLocalStorage(key_local_linea_nego);
    this.route.queryParamMap.subscribe(params => {
      const code = params.get('code');
      this.authService.validateState(params.get('state'));
      this.authService.identify(code).subscribe(
        () => {
          this.authService
            .validateTempPass(this.authService.getRut())
            .subscribe(resTemp => {
              if (resTemp) {
                localStorage.setItem('claveTemporal', '0');
                this.router.navigate([paths.claveTemporal.path]);
                return false;
              } else {
                this.router.navigate([productosPath.path]);
              }
              this.router.navigate([productosPath.path]);
            });
        },
        error => {
          this.authService.requestCode(); // using old code or bad state, request again
        }
      );
    });
  }
}
